export const getAccessToken = () => {
  const tokenCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('sanmina_dashboard_token'))

  return tokenCookie && tokenCookie.split('=')[1]
}
